import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-navy text-white/80 mt-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 font-heading font-extrabold text-white text-lg mb-3">
              <span className="w-8 h-8 rounded-lg bg-teal flex items-center justify-center"><Zap className="w-4 h-4" /></span>
              Beli Motor Listrik
            </div>
            <p className="text-sm leading-relaxed">Bantu Anda memutuskan sebelum membeli motor atau sepeda listrik, dengan bahasa yang mudah dipahami.</p>
          </div>
          <div>
            <h4 className="font-heading font-bold text-white mb-3">Perusahaan</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/tentang" data-testid="footer-tentang">Tentang Kami</Link></li>
              <li><Link to="/kontak" data-testid="footer-kontak">Hubungi Kami</Link></li>
              <li><Link to="/metodologi" data-testid="footer-metodologi">Metodologi</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading font-bold text-white mb-3">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privasi" data-testid="footer-privasi">Kebijakan Privasi</Link></li>
              <li><Link to="/syarat" data-testid="footer-syarat">Syarat & Ketentuan</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading font-bold text-white mb-3">Catatan Penting</h4>
            <p className="text-xs leading-relaxed text-white/60">Semua hasil merupakan estimasi berdasarkan asumsi dan data yang tersedia, bukan jaminan performa atau keselamatan. Selalu lakukan uji langsung sebelum membeli.</p>
          </div>
        </div>
        <div className="border-t border-white/10 mt-10 pt-6 text-xs text-white/50">
          © 2026 Beli Motor Listrik. Data kendaraan dari sumber resmi & daftar pemerintah, diverifikasi bertahap.
        </div>
      </div>
    </footer>
  );
}
